var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "view-compare" },
    [
      _c("p", { staticClass: "print-disclaimer" }, [
        _vm._v(
          "Disclaimer: This is a snapshot of the Tech Platform Assistant. Please note this tool is updated regularly; you can visit the live site for the most current information."
        )
      ]),
      _vm._v(" "),
      _c(
        "section",
        {
          class: ["compare", "compare--chosen--" + _vm.chosenPlatforms.length]
        },
        [
          _c("section", { staticClass: "compare__head" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "link--go-back",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.goBackEvent($event)
                  }
                }
              },
              [_vm._v("\n        Go Back\n      ")]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "chosenPlatforms" },
              _vm._l(_vm.chosenPlatforms, function(platform) {
                return _c(
                  "div",
                  {
                    key: platform[".key"],
                    staticClass: "chosenPlatforms__header"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(platform.displayName) +
                        "\n          "
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "chosenPlatforms__remove",
                        on: {
                          click: function($event) {
                            return _vm.removePlatformEvent(platform)
                          }
                        }
                      },
                      [_vm._v("Remove Platform")]
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "section",
            { staticClass: "compare__body" },
            [
              _c("div", { staticClass: "compare__v-bar-content" }, [
                _c("div", { staticClass: "body__content" }, [
                  _c(
                    "section",
                    { staticClass: "feature-sections" },
                    [
                      _vm._l(_vm.featureSections, function(section) {
                        return _c(
                          "section",
                          {
                            key: section[".key"],
                            class: [
                              {
                                "feature-section": true,
                                "feature-section--collapsed":
                                  _vm.settings.featureCollapse[section[".key"]],
                                "print-hide":
                                  section.displayName === "Pricing" ||
                                  section.displayName === "Sales Contact" ||
                                  section.displayName === "Propr Path"
                              },
                              "feature-section--" + section[".key"]
                            ]
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "feature-section__head" },
                              [
                                _c(
                                  "h3",
                                  {
                                    staticClass: "feature-section__title",
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleFeatureEvent(
                                          section[".key"],
                                          section.displayName,
                                          _vm.settings.featureCollapse[
                                            section[".key"]
                                          ]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(section.displayName) +
                                        "\n                  "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        class: [
                                          "button",
                                          "button--blue",
                                          "button--small",
                                          "button--outline",
                                          {
                                            "button--hover":
                                              _vm.settings.featureCollapse[
                                                section[".key"]
                                              ]
                                          }
                                        ]
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.settings.featureCollapse[
                                                section[".key"]
                                              ]
                                                ? "Show"
                                                : "Hide"
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "feature-section__body" },
                              [
                                _c(
                                  "table",
                                  {
                                    class: [
                                      "features-table",
                                      "features-table--" + section[".key"]
                                    ]
                                  },
                                  _vm._l(
                                    _vm.sortFeatures(section.features),
                                    function(feature) {
                                      return _c(
                                        "tr",
                                        { key: feature[".key"] },
                                        [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "features-table__cell"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "features-table__cell-content"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(feature.displayName)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._l(_vm.chosenPlatforms, function(
                                            platform
                                          ) {
                                            return _c(
                                              "td",
                                              {
                                                key: platform[".key"],
                                                staticClass:
                                                  "features-table__cell-value"
                                              },
                                              [
                                                feature && feature.notesOnly
                                                  ? [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "features-table__cell-value--notes-only"
                                                        },
                                                        [
                                                          platform.features[
                                                            feature[".key"]
                                                          ]
                                                            ? [
                                                                _c("span", {
                                                                  staticClass:
                                                                    "feature-note",
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      platform
                                                                        .features[
                                                                        feature[
                                                                          ".key"
                                                                        ]
                                                                      ].notes
                                                                        ? platform.features[
                                                                            feature[
                                                                              ".key"
                                                                            ]
                                                                          ].notes.trim()
                                                                        : ""
                                                                    )
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.preventDefault()
                                                                      return _vm.handleClick(
                                                                        $event
                                                                      )
                                                                    }
                                                                  }
                                                                })
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  : [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "features-table__cell-value--flex"
                                                        },
                                                        [
                                                          platform.features[
                                                            feature[".key"]
                                                          ]
                                                            ? [
                                                                platform
                                                                  .features[
                                                                  feature[
                                                                    ".key"
                                                                  ]
                                                                ].available ===
                                                                true
                                                                  ? _c(
                                                                      "unum-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "check"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                platform
                                                                  .features[
                                                                  feature[
                                                                    ".key"
                                                                  ]
                                                                ].available ===
                                                                  null ||
                                                                platform
                                                                  .features[
                                                                  feature[
                                                                    ".key"
                                                                  ]
                                                                ].available ===
                                                                  false
                                                                  ? _c(
                                                                      "unum-icon",
                                                                      {
                                                                        attrs: {
                                                                          icon:
                                                                            "x-gray"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                platform
                                                                  .features[
                                                                  feature[
                                                                    ".key"
                                                                  ]
                                                                ].available ===
                                                                "unknown"
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "availability-unknown"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "\n                              Unknown\n                            "
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                platform
                                                                  .features[
                                                                  feature[
                                                                    ".key"
                                                                  ]
                                                                ].notes
                                                                  ? _c(
                                                                      "unum-icon",
                                                                      {
                                                                        directives: [
                                                                          {
                                                                            name:
                                                                              "tooltip",
                                                                            rawName:
                                                                              "v-tooltip",
                                                                            value:
                                                                              platform.features[
                                                                                feature[
                                                                                  ".key"
                                                                                ]
                                                                              ].notes.trim() ||
                                                                              "",
                                                                            expression:
                                                                              "platform.features[feature['.key']].notes.trim() || ''"
                                                                          }
                                                                        ],
                                                                        attrs: {
                                                                          icon:
                                                                            "info"
                                                                        }
                                                                      }
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                platform
                                                                  .features[
                                                                  feature[
                                                                    ".key"
                                                                  ]
                                                                ].notes
                                                                  ? _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "print-tooltip"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Note: " +
                                                                            _vm._s(
                                                                              platform.features[
                                                                                feature[
                                                                                  ".key"
                                                                                ]
                                                                              ].notes.trim() ||
                                                                                ""
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  : _vm._e()
                                                              ]
                                                            : [
                                                                _c(
                                                                  "unum-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon:
                                                                        "x-gray"
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    ]
                                              ],
                                              2
                                            )
                                          }),
                                          _vm._v(" "),
                                          _vm.chosenPlatforms.length < 3
                                            ? _vm._l(
                                                3 - _vm.chosenPlatforms.length,
                                                function(index) {
                                                  return _c("td", {
                                                    key: index,
                                                    staticClass:
                                                      "features-table__cell-value"
                                                  })
                                                }
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.chosenPlatforms, function(platform) {
                        return [
                          platform.platformNotes
                            ? _c(
                                "section",
                                {
                                  key: platform[".key"],
                                  staticClass:
                                    "feature-section__special-programs"
                                },
                                [
                                  _c("table", { class: ["features-table"] }, [
                                    _c(
                                      "tr",
                                      [
                                        _vm._m(1, true),
                                        _vm._v(" "),
                                        _vm._l(_vm.chosenPlatforms, function(
                                          platform
                                        ) {
                                          return _c(
                                            "td",
                                            {
                                              key: platform[".key"],
                                              staticClass:
                                                "features-table__cell-value"
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    platform.platformNotes
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _vm.chosenPlatforms.length < 3
                                          ? _vm._l(
                                              3 - _vm.chosenPlatforms.length,
                                              function(index) {
                                                return _c("td", {
                                                  key: index,
                                                  staticClass:
                                                    "features-table__cell-value"
                                                })
                                              }
                                            )
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.chosenPlatforms.length < 3
                ? _vm._l(3 - _vm.chosenPlatforms.length, function(index) {
                    return _c(
                      "section",
                      {
                        key: index,
                        class: [
                          "platformPlaceholder",
                          "platformPlaceholder--" + index
                        ]
                      },
                      [
                        _c("p", [_vm._v("Add a Platform")]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "platformPlaceholder__add",
                            attrs: { id: "add-platform-button-" + index },
                            on: { click: _vm.addPlatformEvent }
                          },
                          [_vm._v("Add a Platform")]
                        )
                      ]
                    )
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("section", { staticClass: "compare__footer" }, [
            _c(
              "section",
              { staticClass: "chosenPlatformsActions" },
              _vm._l(_vm.chosenPlatforms, function(platform) {
                return _c(
                  "div",
                  {
                    key: platform[".key"],
                    staticClass: "chosenPlatformsActions__cta"
                  },
                  [
                    _c(
                      "unum-button",
                      {
                        attrs: { small: "", outline: "", color: "dark-blue" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.finalSelection(platform)
                          }
                        }
                      },
                      [_vm._v("\n            What's Next?\n          ")]
                    )
                  ],
                  1
                )
              }),
              0
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("drawer-compare-selector")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("Compare"),
      _c("span", { staticClass: "mobile-hide" }, [_vm._v(" Platforms")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "features-table__cell" }, [
      _c("div", { staticClass: "features-table__cell-content" }, [
        _vm._v("Special Programs")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d497465", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d497465","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Compare.vue
// module id = null
// module chunks = 